import { isTaskRemoved } from './taskFilters';

export const getStatusBadgeClass = (status) => {
  const normalized = (status || 'default').replace(/_/g, '-');
  return `status-badge status-badge--${normalized}`;
};

export const getTaskDisplayStatusClass = (task, { treatDraft = false } = {}) => {
  if (isTaskRemoved(task)) {
    return getStatusBadgeClass('removed');
  }
  const status = treatDraft && task?.status === 'draft' ? 'draft' : task?.status;
  return getStatusBadgeClass(status);
};
